import React, {useMemo} from 'react';
import {DefaultTable} from '../../../components/default-table';
import {useIntl} from '../../../hooks/use-intl';
import {RowActionButton} from '../../../components/table-actions-button';
import {FormattedMessage} from 'react-intl';
import {CountryAction} from './useCountryHandlerActions';
import {Country} from '../../../api/DTOs/Country';
import {TableUtils} from '../../../components/table-utils';

interface CountriesTableProps {
  countries: Array<Country>;
  onAction: (country: Country, action: CountryAction) => Promise<unknown>;
}

export const CountriesTable = ({countries, onAction}: CountriesTableProps) => {
  const intl = useIntl();
  const data = countries;

  const columns = useMemo(() => {
    return [
      {
        id: 'Id',
        Header: intl.formatMessage({id: 'ID'}),
        forceApplySize: true,
        maxWidth: 50,
        minWidth: 50,
        accessor: (br: Country) => br.id,
        Cell: ({value}: {value: number}) => {
          return TableUtils.renderBaseContent(value);
        },
      },
      {
        id: 'Title',
        Header: intl.formatMessage({id: 'TITLE'}),
        maxWidth: 200,
        minWidth: 200,
        accessor: (br: Country) => br.name,
        Cell: ({value}: {value: string}) => {
          return TableUtils.renderBaseContent(value);
        },
      },
      {
        id: 'Code',
        Header: intl.formatMessage({id: 'COUNTRY_CODE'}),
        maxWidth: 100,
        minWidth: 100,
        accessor: (br: Country) => br.code,
        Cell: ({value}: {value: string}) => {
          return TableUtils.renderBaseContent(value);
        },
      },
      {
        id: 'Created_At',
        Header: intl.formatMessage({id: 'CREATED_AT'}),
        maxWidth: 100,
        minWidth: 100,
        accessor: (br: Country) => br,
        Cell: ({value}: {value: Country}) => {
          return TableUtils.renderBaseContent(
            <>
              {intl.formatDate(value.created_at)} {intl.formatTime(value.created_at)}
            </>,
          );
        },
      },
      {
        id: 'Updated_at',
        Header: intl.formatMessage({id: 'UPDATED_AT'}),
        maxWidth: 100,
        minWidth: 100,
        accessor: (br: Country) => br,
        Cell: ({value}: {value: Country}) => {
          return TableUtils.renderBaseContent(
            <>
              {intl.formatDate(value.updated_at)} {intl.formatTime(value.updated_at)}
            </>,
          );
        },
      },
      {
        id: 'Action',
        maxWidth: 50,
        accessor: (br: Country) => br,
        Cell: ({value}: {value: Country}) => {
          const actions = [
            {title: intl.formatMessage({id: 'EDIT'}), value: CountryAction.EDIT},
            {title: intl.formatMessage({id: 'DELETE'}), value: CountryAction.DELETE},
          ];
          return TableUtils.renderActionButton(
            <RowActionButton rowDto={value} actions={actions} onSelect={onAction} />,
          );
        },
      },
    ];
  }, []);

  if (countries.length === 0) {
    return (
      <div className={'text-center'}>
        <FormattedMessage id={'NOT_FOUND'} />
      </div>
    );
  }

  return <DefaultTable data={data} columns={columns} />;
};
